
import LoadingSpinner from "components/LoadingSpinner";
import NotificationProvider from "components/NotificationProvider";
import { useGetUserPermissionClaimsQuery } from "features/users/usersSlice";
import { useEffect, useState } from "react";
import { useSaveUserRolesConfigurationMutation } from "../../userManagementSlice";
import UsersPageStyle from "../UsersPageStyle";
import UserPermissionManagement from "./UserPermissionManagement";
import { arrayToObject } from "utils/object-util";

const useStyles = UsersPageStyle;

const EditUserPermissions = ({ userId, onCancel, rolesData, user }) => {
    const classes = useStyles();
    let { data: userPermissions, error: userPermissionsError, isLoading: isLoadingUserPermissions } = useGetUserPermissionClaimsQuery(userId, { skip: !userId });
    let [saveUserRolesConfiguration] = useSaveUserRolesConfigurationMutation();

    const [userRoles, setUserRoles] = useState([]);
    const [permissionClaims, setPermissionClaims] = useState([]);
    const [saving, setSaving] = useState(false);


    const buildDataUserRoles = () => {
        const assignedRoles = [...user?.assignedRole];
        const allMyClaims = [...user?.assignedPermission];
        const claimLookup = arrayToObject(user?.assignedPermission, 'permissionKey');
        if (!assignedRoles || assignedRoles?.length === 0) return;
        let rolesFiltered = rolesData.filter(rol => assignedRoles[0].roleId === rol?.key);

        const rolesUpdated = rolesFiltered?.map((myRole) => {
            const categoriesUpdated = myRole?.categories?.map((category) => {
                const permissionsUpdated = category?.permissions?.map((myPermission) => {
                    const hasClaim = !!claimLookup[myPermission?.key] //allMyClaims?.some((x) => x.permissionKey === myPermission?.key);
                    return {
                        ...myPermission,
                        isActiveInMapping: hasClaim
                    }
                });
                return {
                    ...category,
                    permissions: permissionsUpdated
                }
            });
            return {
                ...myRole,
                categories: categoriesUpdated
            }
        });
        setUserRoles(rolesUpdated);
    }

    useEffect(() => {
        if (!userId) return;
        const getRolesToShow = async () => {
            await buildDataUserRoles();
        }
        getRolesToShow();
    }, [userId, rolesData]);

    useEffect(() => {
        if (!userPermissions?.data) return;
        setPermissionClaims(userPermissions?.data);
    }, [userPermissions?.data]);

    const handleSave = async (request) => {
        setSaving(true);
        let payload = {
            ...request,
            OldList: userRoles,
            ExistingClaims: permissionClaims,
            userId: userId,
        };

        let result = await saveUserRolesConfiguration(payload);

        if (!result?.error) {
            NotificationProvider.success('Saved successfully');
        } else {
            NotificationProvider.error('Failed to save');
        }
        setSaving(false);
    }

    return (
        <>
            <LoadingSpinner loading={saving} />
            <UserPermissionManagement rolesWithAllData={userRoles} refetchRolesWithData={() => { }} handleSave={handleSave} />
        </>
    );
}
export default EditUserPermissions;